import {brandT} from '@tnc/shared';
import {useState} from 'react';

import {distributorT} from '@/lib/types/distributor.types';
import {retailerT} from '@/lib/types/retailer.types';

interface ConfirmApplicationPropsT {
  entity: brandT | retailerT | distributorT;
  entityType: 'brand' | 'retailer' | 'distributor';
  onCancel: () => void;
  onSubmit: (data: {email: string; phone: string; notes: string}) => void;
}

function ConfirmApplicationForm({entity, entityType, onCancel, onSubmit}: ConfirmApplicationPropsT) {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [notes, setNotes] = useState('');

  const handleSubmit = () => {
    onSubmit({email, phone, notes});
  };

  if (!entity || !entityType) {
    return null;
  }

  const getEntityData = () => {
    switch (entityType) {
      case 'brand':
        return {
          name: (entity as brandT).brand_name,
          email: (entity as brandT).brand_email,
          phone: (entity as brandT).brand_phone,
          address: (entity as brandT).brand_address,
          address2: (entity as brandT).brand_address2,
          city: (entity as brandT).brand_city,
          state: (entity as brandT).brand_state,
          postalCode: (entity as brandT).brand_postal_code,
          licenseNumber: (entity as brandT).brand_license_number,
        };
      case 'retailer':
        return {
          name: (entity as retailerT).retailer_name,
          email: (entity as retailerT).retailer_email,
          phone: (entity as retailerT).retailer_phone,
          address: (entity as retailerT).retailer_address,
          address2: (entity as retailerT).retailer_address2,
          city: (entity as retailerT).retailer_city,
          state: (entity as retailerT).retailer_state,
          postalCode: (entity as retailerT).retailer_postal_code,
          licenseNumber: (entity as retailerT).retailer_license_number,
        };
      case 'distributor':
        return {
          name: (entity as distributorT).distributor_name,
          email: (entity as distributorT).distributor_email,
          phone: (entity as distributorT).distributor_phone,
          address: (entity as distributorT).distributor_address,
          address2: (entity as distributorT).distributor_address2,
          city: (entity as distributorT).distributor_city,
          state: (entity as distributorT).distributor_state,
          postalCode: (entity as distributorT).distributor_postal_code,
          licenseNumber: (entity as distributorT).distributor_license_number,
        };
      default:
        return {
          name: '',
          email: '',
          phone: '',
          address: '',
          address2: '',
          city: '',
          state: '',
          postalCode: '',
          licenseNumber: '',
        };
    }
  };

  const entityData = getEntityData();

  return (
    <div className="rounded-md border p-4 shadow-md">
      <h2 className="mb-4 text-lg font-semibold">Confirm Your Selection</h2>
      <p className="mb-2">
        You have selected: <strong>{entityData?.name}</strong>
      </p>
      <div className="mb-4">
        <label htmlFor="contact-email" className="form-label text-default">
          Contact Email
        </label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="form-control form-control-lg w-full !rounded-md"
          placeholder={entityData?.email || ''}
        />
      </div>
      <div className="mb-4">
        <label htmlFor="contact-phone" className="form-label text-default">
          Contact Phone Number
        </label>
        <input
          type="tel"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          className="form-control form-control-lg w-full !rounded-md"
          placeholder={entityData?.phone || ''}
        />
      </div>
      <div className="mb-4">
        <label className="mb-1 block">Notes</label>
        <textarea value={notes} onChange={e => setNotes(e.target.value)} className="w-full rounded border p-2" />
      </div>
      <div className="flex justify-end space-x-2">
        <button onClick={onCancel} className="ti-btn ti-btn-secondary">
          Cancel
        </button>
        <button onClick={handleSubmit} className="ti-btn ti-btn-primary">
          Submit
        </button>
      </div>
    </div>
  );
}

export default ConfirmApplicationForm;
